module.exports = __webpack_public_path__ + "static/media/Coming for You.5ab7e280.jpg";